/** Presentation tokens and shared sx for the mockup generator editor. */
export const GENERATOR_MODAL_MIN_HEIGHT = 800;

export const EDITOR_UI = {
  pageBg: "#F8FAFC",
  workspaceBg: "#F5F6FA",
  primary: "#4F46E5",
  primaryLight: "#6366F1",
  border: "rgba(15, 23, 42, 0.08)",
  cardShadow: "0 1px 2px rgba(15, 23, 42, 0.05), 0 8px 24px rgba(15, 23, 42, 0.06)",
  leftWidth: 300,
  leftCollapsedWidth: 52,
  dotGrid:
    "radial-gradient(circle, rgba(15, 23, 42, 0.07) 1px, transparent 1px)",
} as const;

export const editorFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    fontSize: 14,
    bgcolor: "#FAFBFC",
    transition: "box-shadow 0.15s ease, border-color 0.15s ease",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: EDITOR_UI.primaryLight,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: EDITOR_UI.primary,
      borderWidth: 1,
    },
    "&.Mui-focused": {
      boxShadow: "0 0 0 3px rgba(79, 70, 229, 0.12)",
    },
  },
  "& .MuiInputLabel-root": { fontSize: 13 },
};

export const editorIconBtnSx = {
  border: "1px solid",
  borderColor: EDITOR_UI.border,
  borderRadius: 1.5,
  bgcolor: "common.white",
  transition: "all 0.15s ease",
  "&:hover": {
    bgcolor: "#F5F3FF",
    borderColor: EDITOR_UI.primaryLight,
  },
};

export const logoCardSx = (isSelected: boolean) => ({
  position: "relative" as const,
  width: "100%",
  aspectRatio: "1 / 1",
  border: "2px solid",
  borderColor: isSelected ? EDITOR_UI.primary : EDITOR_UI.border,
  borderRadius: 2.5,
  bgcolor: "common.white",
  p: 1.25,
  cursor: "grab",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  boxShadow: isSelected
    ? "0 0 0 3px rgba(79, 70, 229, 0.18), 0 8px 20px rgba(79, 70, 229, 0.12)"
    : EDITOR_UI.cardShadow,
  transition: "transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    borderColor: isSelected ? EDITOR_UI.primary : EDITOR_UI.primaryLight,
    boxShadow: isSelected
      ? "0 0 0 3px rgba(79, 70, 229, 0.22), 0 12px 28px rgba(79, 70, 229, 0.14)"
      : "0 8px 24px rgba(15, 23, 42, 0.08)",
  },
  "& .logo-card-delete": { opacity: 0 },
  "&:hover .logo-card-delete": { opacity: 1 },
});

export const logoDeleteBtnSx = {
  position: "absolute" as const,
  bottom: 6,
  right: 6,
  width: 28,
  height: 28,
  bgcolor: "#FEE2E2",
  color: "#DC2626",
  cursor: "pointer",
  boxShadow: "0 1px 4px rgba(220, 38, 38, 0.15)",
  transition: "background-color 0.15s ease, transform 0.12s ease",
  "&:hover": { bgcolor: "#FCA5A5", color: "#B91C1C" },
};

export const printAreaSx = {
  border: "1px dashed",
  borderColor: "rgba(79, 70, 229, 0.35)",
  borderRadius: 1.5,
  bgcolor: "rgba(79, 70, 229, 0.03)",
  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.5)",
};

export const logoSelectionSx = (isDragging: boolean) => ({
  border: "1.5px solid",
  borderColor: EDITOR_UI.primary,
  boxSizing: "border-box" as const,
  boxShadow:
    "0 0 0 1px rgba(255,255,255,0.95), 0 0 0 4px rgba(79, 70, 229, 0.18), 0 4px 12px rgba(79, 70, 229, 0.12)",
  cursor: isDragging ? "grabbing" : "grab",
  transition: "box-shadow 0.15s ease",
});

export const resizeHandleSx = {
  position: "absolute" as const,
  right: -6,
  bottom: -6,
  width: 11,
  height: 11,
  backgroundColor: "#FFFFFF",
  borderRadius: "50%",
  cursor: "nwse-resize",
  border: `2px solid ${EDITOR_UI.primary}`,
  boxShadow: "0 2px 8px rgba(79, 70, 229, 0.35)",
  zIndex: 11,
  transition: "transform 0.12s ease, box-shadow 0.12s ease",
  "&:hover": { transform: "scale(1.2)", boxShadow: "0 3px 10px rgba(79, 70, 229, 0.45)" },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 2,
    borderRadius: "50%",
    bgcolor: EDITOR_UI.primary,
  },
};

export const MOCKUP_EXPORT_ZOOM_SCALE = 1.65;
export const EXPORT_CARD_PREVIEW_HEIGHT = 180;
